
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { Subscription } from 'rxjs';
    import { dia } from '@clientio/rappid';
    import MessageInspector from 'src/components/Chatbot/Inspector/Message-inspector/Message-inspector.vue';
    import LabelInspector from 'src/components/Chatbot/Inspector/Label-inspector/Label-inspector.vue';
    import LinkInspector from 'src/components/Chatbot/Inspector/Link-inspector/Link-inspector.vue';
    import { SharedEvents } from 'src/rappid/controller';
    import { ShapeTypesEnum } from 'src/rappid/shapes/app.shapes';
    @Component({
        components: {
            MessageInspector,
            LinkInspector,
            LabelInspector
        }
    })
    export default class Inspector extends Vue {
        public cell: dia.Cell = null;
        public subscriptions = new Subscription();
        public shapeTypesEnum = ShapeTypesEnum;
        public mounted(): void {
            this.subscriptions.add(
                this.$eventBusService.on(SharedEvents.SELECTION_CHANGED, (selection: dia.Cell[]) => this.setCell(selection))
            );
        }
        public beforeDestroy(): void {
            this.subscriptions.unsubscribe();
        }
        private setCell(selection: dia.Cell[]): void {
            const [cell = null] = selection;
            this.cell = cell;
        }
    }
